import { render } from "./search-seolink.vue?vue&type=template&id=3072264c"
import script from "./search-seolink.js?vue&type=script&lang=js"
export * from "./search-seolink.js?vue&type=script&lang=js"

import "./search-seolink.vue?vue&type=style&index=0&id=3072264c&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__